module.exports = __webpack_public_path__ + "static/img/bcg0.fc3487fe.webp";